import React from 'react';
import { Loader } from '../components/Loader';
import { ProfileHeader } from '../components/profile/ProfileHeader';
import { SubscriptionStatusSection } from '../components/profile/SubscriptionStatusSection';
import { ReferralSection } from '../components/profile/ReferralSection';
import { PremiumSection } from '../components/profile/PremiumSection';
import { SupportSection } from '../components/profile/SupportSection';
import { useUserStore } from '../stores/useUserStore';
import { useReferralStore } from '../stores/useReferralStore';

const ProfileScreen: React.FC = () => {
  const { subscriptionStatus, user, loading: subscriptionLoading, updateUser, reloadSubscription } = useUserStore();
  const { referralStats, loading: referralLoading, copyReferralLink } = useReferralStore();

  const loading = subscriptionLoading || referralLoading;

  const handlePaymentSuccess = () => {
    reloadSubscription();
  };

  const handleCopyReferralCode = async () => {
    try {
      await copyReferralLink(user.referralCode);
    } catch (error) {
      console.error('Failed to copy referral link:', error);
    }
  };

  if (loading) {
    return (
      <div className="flex flex-col gap-4 min-h-screen pb-2">
        <div className="flex justify-center items-center min-h-screen w-full">
          <Loader />
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4 min-h-screen pb-2 max-[360px]:gap-3">
      <ProfileHeader user={user} onUserUpdate={updateUser} />
      
      <SubscriptionStatusSection subscriptionStatus={subscriptionStatus} />
      
      <ReferralSection
        referralStats={referralStats}
        referralCode={user.referralCode}
        onCopyReferralCode={handleCopyReferralCode}
      />
      
      <PremiumSection onSuccess={handlePaymentSuccess} />
      
      <SupportSection />
    </div>
  );
};

export default ProfileScreen;
